<div class="flex flex-col h-full w-full justify-start items-start gap-6 pb-6 font-medium bg-[#FFF]">
  <app-quality-stepper [selectedStep]="1" [previousStepAllowed]="true" class="w-full"></app-quality-stepper>

  <div class="flex flex-col w-full flex-1 min-h-0 justify-start items-start gap-6 px-6">
    <div class="w-full">
      <app-overview-reports (download)="downloadReport()"
                            [activateDownload]="!loading"
                            [checkerName]="(qualityCheck?.checker?.firstName ?? '') + ' ' + (qualityCheck?.checker?.lastName ?? '')"
                           [completedValue]="statusSummary.completed"
                            [date]="qualityCheck.checkDate"
                           [errorValue]="statusSummary.error"
                           [fileDeactivated]="true"
                            [info2]="qualityCheck?.qualityCheckProjectFiles?.length ?? 0"
                            [loading]="loading"
                           [warningValue]="statusSummary.warning"
                            [rules]="checkedRuleCount.toString()"
                           checkType="QUALITY"
                           info1="All-Right Check">
      </app-overview-reports>
    </div>

    <div class="flex w-full flex-1 min-h-0 overflow-hidden">
      <bic-result>
        <bic-result-column #filesColumn (selectedElementChange)="selectedRule = undefined"
                           [(selectedElement)]="selectedFile"
                           [style.flex]="'25 1 0%'" [style.max-width]="'100%'" [style.min-width]="'0'">
          <bic-result-header>
            <div class="w-full flex flex-row justify-between">
              <div>
                Dateien
              </div>

              <div>
                Ergebnis
              </div>
            </div>
          </bic-result-header>

          @if (loading) {
            <bic-result-row [disableTasks]="true" [hidden]="true"></bic-result-row>
            <div class="flex flex-col flex-1 h-full justify-center items-center py-16">
              <div class="flex flex-row items-center gap-2">
                <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
                <span class="text-sm font-medium text-gray-500">Ergebnisse werden geladen...</span>
              </div>
            </div>
          } @else {
          @for (file of qualityCheck.qualityCheckProjectFiles; track file.id) {
            <bic-result-row #row (taskClicked)="createTaskForFile(file)" [status]="statusForProjectFile(file)"
                            [value]="file">
              <div class="flex flex-row flex-1 gap-4 min-w-0">
                <div class="text-center flex-shrink-0">
                  {{ file.fileType }}
                </div>

                <div class="truncate">
                  {{ file.projectFile!.name }}
                </div>
              </div>

              <div class="flex flex-row justify-end gap-4 flex-shrink-0">
                <div>
                  {{ resultPercentageForFile(file) }} %
                </div>
              </div>

            </bic-result-row>
          }
          }
        </bic-result-column>
        <bic-result-column #rulesColumn [(selectedElement)]="selectedRule" [style.flex]="'25 1 0%'"
                           [style.max-width]="'100%'" [style.min-width]="'0'" emptyText="Bitte Datei auswählen">
          <bic-result-header header>
            <div class="w-full flex flex-row justify-between">
              <div>
                Prüfregeln
              </div>

              <div>
                Ergebnis
              </div>
            </div>
          </bic-result-header>

          @for (rule of rulesOfSelectedProjectFile; track rule.id) {
            <bic-result-row (taskClicked)="createTaskForRuleAndSelectedFile(rule)" [status]="statusForRuleAndSelectedFile(rule)"
                            [value]="rule">

              <div class="flex flex-row flex-1 gap-4 min-w-0">
                <div class="truncate">
                  @if (selectedRule && !rulesColumn.isHovered && !rulesColumn.fixed) {
                    {{ rule.name.split(' ')[0] }} {{ rule.name.split(' ')[1] }}
                  } @else {
                    {{ rule.name }}
                  }
                </div>
              </div>

              <div class="flex flex-row justify-end gap-4 flex-shrink-0">
                <div>
                  {{ resultPercentageForRuleAndSelectedFile(rule) }} %
                </div>
              </div>
            </bic-result-row>
          }
        </bic-result-column>
        <bic-result-column [style.flex]="'50 1 0%'"
                           [style.max-width]="'100%'" [style.min-width]="'0'" emptyText="Bitte Prüfregel auswählen">
          <bic-result-header header>
            <div class="w-full flex flex-row justify-between min-w-0">
              <div class="flex flex-row flex-1 gap-4 min-w-0">
                Ergebnis
              </div>

              <div class="flex flex-row justify-end gap-4 flex-shrink-0 w-16">
                Bauteile
              </div>
            </div>
          </bic-result-header>

          @if (selectedRule) {
            <bic-result-row [disableTasks]="true" [lineBreaksDisabled]="false">
              <div class="flex flex-col h-full w-full">
                @for (result of resultOfSelectedProjectFileAndSelectedRule; track $index; let last = $last) {
                  <div class="flex flex-row w-full gap-4 py-2 px-4 min-w-0">
                    <div class="flex flex-col justify-center items-center text-base flex-shrink-0">
                      @switch (result.type) {
                        @case ("success") {
                          <fa-icon [icon]="faCircleCheck" class="text-green"></fa-icon>
                        }
                        @case ("warning") {
                          <fa-icon [icon]="faCircleExclamation" class="text-yellow"></fa-icon>
                        }
                        @case ("error") {
                          <fa-icon [icon]="faCircleXmark" class="text-red"></fa-icon>
                        }
                      }
                    </div>
                    <div class="flex flex-row flex-1 min-w-0">
                      <div>
                        {{ result.responseText }}
                      </div>
                    </div>
                    <div class="flex flex-row justify-center gap-4 flex-shrink-0 w-16 text-center">
                        {{ result.count }}
                    </div>
                  </div>
                  @if (!last) {
                    <div class="border-t"></div>
                  }
                }
              </div>
            </bic-result-row>
          }
        </bic-result-column>
      </bic-result>
    </div>

  </div>
</div>
